module.exports = __webpack_public_path__ + "f21bfeb40f9aa212ba7cd85927afc0ee.ttf";